import React from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";

// Pill switcher with a count on each option, e.g. Active (12) / Archived (3).
function EmployeesTabs({ tabs, value, onChange }) {
  return (
    <SuiBox display="flex" gap={1} mb={2}>
      {tabs.map((tab) => {
        const selected = tab.value === value;
        return (
          <SuiBox
            key={tab.value}
            component="button"
            type="button"
            onClick={() => onChange(tab.value)}
            sx={{
              height: 32,
              px: 2,
              border: "none",
              borderRadius: "16px",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
              color: selected ? "#fff !important" : "#4b5a73 !important",
              backgroundColor: selected ? "#344767" : "#eef0f4",
            }}
          >
            {tab.label} ({tab.count})
          </SuiBox>
        );
      })}
    </SuiBox>
  );
}

EmployeesTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EmployeesTabs;
